import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { valueStack, valuePriced, valueTotals, offers, media } from '../data/product';
import { CtaButton } from './CtaButton';
import { requestOffer } from '../utils/offerBus';
import { GuaranteeBadge, ShopHotspot } from './BannerOverlays';
export function ValueStackSection() {
  return <section aria-labelledby="value-heading" className="border-b border-white/10 bg-ink-950" data-id="element-1502" data-mp="1he09l125i4pq">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-1503" data-mp="tnw8p1gckj2f">
        <h2 id="value-heading" className="grit-headline max-w-3xl text-[clamp(2.25rem,8vw,4rem)] font-extrabold uppercase text-offwhite" data-id="element-1504" data-mp="opunoazd29ob">
          The complete
          <br data-id="element-1505" data-mp="ylo25zwn4d8q" />
          <span className="text-grit-500" data-id="element-1506" data-mp="yl5vsag9kin3">GritVue X1 system.</span>
        </h2>
        <p className="mt-4 max-w-2xl text-lg text-steel-300" data-id="element-1507" data-mp="2e2g3188dsy84">
          Built for real work. The GritVue X1™ combines hands-free illumination, interchangeable lenses and a
          complete care system in one premium, work-ready package.
        </p>

        <div className="mt-10 grid gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:items-start" data-id="element-1508" data-mp="1nfbci45kpqwt">
          <div className="border border-white/12 bg-ink-900" data-id="element-1509" data-mp="1se5z7h6nvzm7">
            <p className="border-b border-white/10 px-5 py-4 text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400 sm:px-6" data-id="element-1510" data-mp="1weyd4nqhasot">
              Everything included
            </p>
            <ul data-id="element-1511" data-mp="14na5geinaucb">
              {valuePriced.map(row => <li key={row.item} className="flex items-start justify-between gap-5 border-b border-white/5 px-5 py-4 sm:px-6" data-id="element-1512" data-mp="18o2bz004ul4w">
                  <span className="min-w-0" data-id="element-1513" data-mp="1dl2krioda1zp">
                    <span className="block text-base font-semibold text-offwhite sm:text-lg" data-id="element-1514" data-mp="1ie5ebqt59bfw">{row.item}</span>
                    <span className="mt-0.5 block text-[13px] text-steel-500" data-id="element-1515" data-mp="kxghkbj1wzdd">{row.note}</span>
                  </span>
                  <span className="shrink-0 text-right" data-id="element-1516" data-mp="pw02q9ptm74o">
                    <span className="block font-display text-2xl font-bold leading-none text-steel-300" data-id="element-1517" data-mp="1t7yrek04h7lb">
                      {row.price}
                    </span>
                    {row.price.startsWith('$') && <span className="mt-0.5 block text-[10px] font-bold uppercase tracking-[0.16em] text-steel-500" data-id="element-1518" data-mp="21zqx6he7bsjk">
                        Value
                      </span>}
                  </span>
                </li>)}
            </ul>

            <div className="flex items-center justify-between gap-5 border-b border-white/10 px-5 py-4 sm:px-6" data-id="element-1519" data-mp="15b2ucsb24buq">
              <span className="font-display text-xl font-bold uppercase tracking-wide text-offwhite" data-id="element-1520" data-mp="1jakn1irh499d">
                Total separate value
              </span>
              <span className="font-display text-3xl font-extrabold leading-none text-offwhite" data-id="element-1521" data-mp="1edkgz7umj6i9">
                {valueTotals.total}
              </span>
            </div>
            <div className="flex items-center justify-between gap-5 border-b border-white/10 px-5 py-4 sm:px-6" data-id="element-1522" data-mp="2ppv4ozuigcfu">
              <span className="min-w-0" data-id="element-1523" data-mp="2y9hv7r0c1hez">
                <span className="block font-display text-xl font-bold uppercase tracking-wide text-steel-400" data-id="element-1524" data-mp="329ib7g32y0o5">
                  Built piece by piece
                </span>
                <span className="mt-0.5 block text-[13px] text-steel-500" data-id="element-1525" data-mp="2t8anfry6wi8b">X1 Essential + Full Lens System + hard case</span>
              </span>
              <span className="font-display text-3xl font-extrabold leading-none text-steel-400" data-id="element-1526" data-mp="3gyxz8ob87s05">
                {valueTotals.builtSeparately}
              </span>
            </div>
            <div className="flex items-center justify-between gap-5 border-b border-white/10 bg-ink-850 px-5 py-4 sm:px-6" data-id="element-1527" data-mp="378lccpfxvmqu">
              <span className="font-display text-xl font-bold uppercase tracking-wide text-offwhite" data-id="element-1528" data-mp="3c5vbwxx1lese">
                As a Complete System
              </span>
              <span className="text-right" data-id="element-1529" data-mp="8htey9ng98rz">
                <span className="block font-display text-3xl font-extrabold leading-none text-grit-500" data-id="element-1530" data-mp="8jnz3lqwcwv0">
                  {valueTotals.payOne}
                </span>
                <span className="mt-1 block text-[11px] font-bold uppercase tracking-[0.18em] text-grit-500" data-id="element-1531" data-mp="2bzjeufi445y7">
                  {valueTotals.saveVsBuilt} less, plus pouch and cloth
                </span>
              </span>
            </div>

            <a href="#offer" onClick={event => {
            event.preventDefault();
            requestOffer('single');
          }} className="group block bg-grit-500 px-5 py-6 text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px] focus:outline-none focus-visible:ring-2 focus-visible:ring-offwhite sm:px-6" data-id="element-1532" data-mp="223pwuglmjk91">
              <p className="text-[11px] font-bold uppercase tracking-[0.2em]" data-id="element-1533" data-mp="3ifv9i6lq75p1">Complete System price</p>
              <p className="mt-2 flex flex-wrap items-end gap-x-4 gap-y-1" data-id="element-1534" data-mp="3dowowutpflfz">
                <span className="font-display text-5xl font-extrabold leading-none sm:text-6xl" data-id="element-1535" data-mp="3dnlnv2rn8rsk">
                  {valueTotals.payOne}
                </span>
                <span className="pb-1.5 font-display text-lg font-bold uppercase sm:text-xl" data-id="element-1536" data-mp="3q0fng1vi4g69">
                  for the complete system
                </span>
              </p>
              <p className="mt-3 font-display text-xl font-extrabold uppercase leading-tight sm:text-2xl" data-id="element-1537" data-mp="3spokapb0960">
                Or {valueTotals.payEach} per X1 with Buy 2, Get 1 Free.
              </p>
              <p className="mt-4 inline-flex items-center gap-2 font-display text-xl font-extrabold uppercase tracking-wide" data-id="element-1538" data-mp="cscfu3objylc">
                Choose your pack
                <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-grit group-hover:translate-x-1" aria-hidden="true" data-id="element-1539" data-mp="hm6z5600ibjw" />
              </p>
            </a>
          </div>

          <div data-id="element-1540" data-mp="viu4nx616a1f">
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-1541" data-mp="vkf3hyzdof53">In every Complete System</p>
            <ul className="mt-4 max-w-md" data-id="element-1542" data-mp="2skhv146kkil5">
              {valueStack.map(item => <li key={item} className="flex items-center gap-3 border-b border-white/10 py-3.5 text-base font-medium text-offwhite sm:text-lg" data-id="element-1543" data-mp="2nmq5ggted8k4">
                  <CheckIcon className="h-5 w-5 shrink-0 text-grit-500" aria-hidden="true" data-id="element-1544" data-mp="2wka4dj3sesrk" />
                  {item}
                </li>)}
            </ul>

            <figure className="mt-8 border border-white/10 bg-ink-900" data-id="element-1545" data-mp="36albfeirpi2o">
              <div className="relative" data-id="element-1546" data-mp="3kb5tg8guz9v4">
                <img src={media.detailSheet} alt="The GritVue X1 frame with its light module, clear, amber and smoke lenses and USB-C charging" className="block h-auto w-full" data-id="element-1547" data-mp="3ka4lwdz1x5i5" />
                <GuaranteeBadge compact box={{
                left: '17.2%',
                top: '37.4%',
                width: '17.4%',
                height: '9.2%'
              }} data-id="element-1548" data-mp="1lvt6jmi329oy" />
                <ShopHotspot box={{
                left: '3.3%',
                top: '38.4%',
                width: '14.2%',
                height: '7%'
              }} data-id="element-1549" data-mp="1bso4zmvodiqi" />
              </div>
              <figcaption className="border-t border-white/10 px-4 py-3 text-[13px] text-steel-400" data-id="element-1550" data-mp="1fvkjp2i3gup6">
                The X1 Complete System: illuminated frame, all three lenses and USB-C charging.
              </figcaption>
            </figure>

            <ul className="mt-6 grid grid-cols-1 gap-px bg-white/10 sm:grid-cols-3" data-id="element-1551" data-mp="s3m1rzo54132">
              {offers.map(offer => <li key={offer.id} data-id="element-1552" data-mp="x4jkqegz4z5m">
                  <a href="#offer" onClick={event => {
                event.preventDefault();
                requestOffer(offer.id);
              }} aria-label={`${offer.units} for ${offer.price}. Go to this pack`} className={`block h-full px-4 py-4 transition-[background-color,transform] duration-150 ease-grit active:translate-y-[2px] focus:outline-none focus-visible:ring-2 focus-visible:ring-grit-500 ${offer.featured ? 'bg-grit-500 text-ink-950 hover:bg-grit-400' : 'bg-ink-900 hover:bg-ink-800'}`} data-id="element-1553" data-mp="j374e1xwivj7">
                    <p className={`font-display text-xl font-extrabold uppercase leading-none ${offer.featured ? 'text-ink-950' : 'text-offwhite'}`} data-id="element-1554" data-mp="3h94bhvxln87l">
                      {offer.kicker}
                    </p>
                    <p className={`mt-1 font-display text-3xl font-extrabold leading-none ${offer.featured ? 'text-ink-950' : 'text-grit-500'}`} data-id="element-1555" data-mp="339uuwv5hec33">
                      {offer.price}
                    </p>
                    <p className={`mt-1 text-[11px] font-bold uppercase tracking-wide ${offer.featured ? 'text-ink-950/70' : 'text-steel-400'}`} data-id="element-1556" data-mp="wjx0b0lw12wu">
                      {offer.perUnit ?? offer.discountBadge ?? 'Single system'}
                    </p>
                  </a>
                </li>)}
            </ul>

            <p className="grit-headline mt-8 text-[clamp(1.75rem,6vw,3rem)] font-extrabold uppercase text-offwhite" data-id="element-1557" data-mp="2k8x2cu3zop1f">
              See further.
              <br data-id="element-1558" data-mp="1rinhm0i5ql6l" />
              <span className="text-grit-500" data-id="element-1559" data-mp="1rj6vn64ospfc">Work smarter.</span>
            </p>
            <p className="mt-3 text-[15px] font-semibold uppercase tracking-wide text-steel-300" data-id="element-1560" data-mp="1wg6vv0euuxyj">
              Built for the people who keep America moving.
            </p>
            <p className="mt-1 text-[13px] text-steel-500" data-id="element-1561" data-mp="25hertbtwfmpg">Prescription ready.</p>

            <CtaButton offer="trio" className="mt-6 w-full sm:w-auto" data-id="element-1562" data-mp="25fafc5hxpfdk">
              Get 3 X1 Systems for $99.90
            </CtaButton>
          </div>
        </div>
      </div>
    </section>;
}